import { withMetrics } from "@expert/cloudwatch-metrics";
import { getLogger } from "@expert/logging";
import { HTTPError } from "ky";

import { getSharedApiClient } from "@/shared-utils";

import type { SurveyRequest, SurveyResponse } from "./types";

import { env } from "../environment";

const logger = getLogger({
    module: "sendSurveyData",
});

/**
 * @see https://ivr3.dev.rtt.contactcenter.npr.aws.asurion.net/docs#put-/api/v1/middletier/survey/data/soluto/-callId-
 */
export async function sendSurveyData(callId: string, requestBody: SurveyRequest): Promise<void> {
    try {
        await withMetrics(
            "sendSurveyData",
            async () => {
                try {
                    const data = await getSharedApiClient()
                        .put(`api/v1/middletier/survey/data/soluto/${callId}`, {
                            prefix: env.ivrApisBaseUrl,
                            json: requestBody,
                        })
                        .json<SurveyResponse>();
                    logger.info({ data }, "Send survey data API call successful");
                    return data;
                } catch (error) {
                    if (!(error instanceof HTTPError)) throw error;
                    const errorText = await error.response.text();
                    logger.error({ error, errorText }, "Send survey data API call failed");
                    throw error;
                }
            },
            { logger, rethrow: false },
        );
    } catch (error: unknown) {
        // TODO: @asurion-core/expert-workspace-platform: refactor error handing.
        const status = error instanceof HTTPError && error.response.status;
        logger.error({ error, status }, "Unexpected error sending survey data");
    }
}
